import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw[] = [
  {
    path: '/console/device',
    redirect: '/console/device/list',
    meta: {
      title: '设备',
      menu: false,
    },
  },
  {
    path: '/console/device/add',
    component: Layout,
    meta: {
      title: '添加设备',
      icon: 'i-lucide:circle-plus',
    },
    children: [
      {
        path: '',
        name: 'deviceAdd',
        component: () => import('@/views/device/add.vue'),
        meta: {
          title: '添加设备',
          menu: false,
          breadcrumb: false,
        },
      },
    ],
  },
  {
    path: '/console/device/list',
    component: Layout,
    meta: {
      title: '设备列表',
      icon: 'i-lucide:list',
    },
    children: [
      {
        path: '',
        name: 'deviceList',
        component: () => import('@/views/device/list.vue'),
        meta: {
          title: '设备列表',
          menu: false,
          breadcrumb: false,
        },
      },
    ],
  },
  {
    path: '/console/device/commands',
    component: Layout,
    meta: {
      title: '命令下发',
      icon: 'i-lucide:terminal',
    },
    children: [
      {
        path: '',
        name: 'deviceCommands',
        component: () => import('@/views/device/commands.vue'),
        meta: {
          title: '命令下发',
          menu: false,
          breadcrumb: false,
        },
      },
    ],
  },
  {
    path: '/console/device/alarms',
    component: Layout,
    meta: {
      title: '告警中心',
      icon: 'i-lucide:triangle-alert',
    },
    children: [
      {
        path: '',
        name: 'deviceAlarms',
        component: () => import('@/views/device/alarms.vue'),
        meta: {
          title: '告警中心',
          menu: false,
          breadcrumb: false,
        },
      },
    ],
  },
  {
    path: '/console/device/jobs',
    component: Layout,
    meta: {
      title: '加工任务',
      icon: 'i-lucide:list-checks',
    },
    children: [
      {
        path: '',
        name: 'deviceJobs',
        component: () => import('@/views/device/jobs.vue'),
        meta: {
          title: '加工任务',
          menu: false,
          breadcrumb: false,
        },
      },
    ],
  },
  {
    path: '/console/device/:deviceId',
    component: Layout,
    meta: {
      title: '设备详情',
      menu: false,
    },
    children: [
      {
        path: '',
        name: 'deviceDetail',
        component: () => import('@/views/device/detail.vue'),
        meta: {
          title: '设备详情',
          menu: false,
        },
      },
    ],
  },
]

export default routes
